$(function(){
    $(".basket__item-delete").click(function() {
        window.setTimeout('location.reload()', 500);
    });
});